module.exports = __webpack_public_path__ + "static/media/ban-khar-analysis.1cb05ac2.svg";